import React, { useContext, useEffect, useState } from 'react';
import PaymentSettingsLink from '../components/paymentSettings/PaymentSettingsLink';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import SideLeft from '../layout/SideLeft';
import AppContext from '../Context/AppContext';
import SideMinTalk from '../layout/SideMinTalk';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import CenterTalk from '../components/CenterTalk';
import StatProjects from '../components/StatProjects';
import { useParams, useLocation } from "react-router-dom";
import CenterTalkSearch from '../components/CenterTalkSearch';


const MessageUser = () => {
    const [selectTalk, setSelectTalk] = useState()
    const [searchTalk, setSearchTalk] = useState()
    const { setCurrentPage } = useContext(AppContext)
    const [iMessages, setImessages] = useState(null)
    const [userOnline, setUserOnline] = useState([])
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const { id } = useParams();
    const location = useLocation()
    const { socket, setMessageUser } = useSocket()
    const userToken = infoUser()


    const fetchImessage = (p = 1) => {
        socket.emit('empire_tracker_all_message', { token: userToken.expecttoken, page: p }, (e) => {
            console.log("empire_tracker_all_message",e);
            
            setMessageUser(false)
            const arr = Array.isArray(e) ? e : (e?.data || [])
            setTotalPage(Array.isArray(e) ? 1 : (e?.total_page || 1))
            setPage(Array.isArray(e) ? 1 : (e?.current_page || 1))
            setImessages(prev => (p > 1 && prev) ? [...prev, ...arr] : arr)
        })
    }
    const loadMore = () => {
        if (page < totalPage) fetchImessage(page + 1)
    }
    const initMessage = () => {
        if (socket) {
            fetchImessage()
            socket.on('notif_new_message', (e) => {
                fetchImessage()
            })
        }
    }
    const initUserOnline = () => {
        if (socket) {
            socket.emit('empire_get_user_online', { token: userToken.expecttoken }, (e) => {
                setUserOnline(e)
            })
            socket.on('notif_get_user_onine', (e) => {
                setUserOnline(e)
            })
        }
    }
    useEffect(() => {
        initMessage()
        initUserOnline()
        setCurrentPage('message_user')
    }, [socket])

    useEffect(() => {
        if (id && iMessages?.length > 0) {
            const findMessageAlready = iMessages.find(el => el.user.id == id);
            if (findMessageAlready) {
                setSelectTalk(findMessageAlready)
            }
        }
    }, [id, iMessages])

    useEffect(() => {
        const search = location.state?.search
        if (socket && search) {
            socket.emit('empire_search_user_talk', { token: userToken.expecttoken, search }, (e) => {
                setSearchTalk(e)
            })
        }
    }, [socket, location.state])
    return (
        <MainLayout addClass={(selectTalk && !searchTalk) ? 'talk-open' : ''}>
            <SideMinTalk
                iMessages={iMessages}
                userOnline={userOnline}
                currentPage={page}
                totalPage={totalPage}
                onLoadMore={loadMore}
                onSearch={(e) => {
                    setSearchTalk(e)
                }}
                onSelect={(e) => {
                    setSelectTalk(e)
                    setSearchTalk(null)
                }}>

            </SideMinTalk>
            <CenterLayout>
                {searchTalk && (
                    <CenterTalkSearch result={searchTalk} selectConversation={v => {
                        const findMessage = iMessages.find(el => el.user.id == v.user_id)
                        if (findMessage) {
                            setSelectTalk(findMessage)
                            setSearchTalk(null)
                        } else {
                            console.log(v);

                            const newUser = { last_message_date: null, messages: [], user: { email: v.email, id: v.user_id, isOnline: [], path: v.path, slug: v.firstname + " " + v.lastname } }
                            setImessages(prev => [...prev, newUser])
                            setSelectTalk(newUser)
                            setSearchTalk(null)
                        }
                    }} />
                )}
                {!searchTalk && selectTalk && iMessages && (
                    <CenterTalk el={selectTalk} iMessages={iMessages} init={fetchImessage} onBack={() => setSelectTalk(null)} />
                )}
            </CenterLayout>

            <SideLeft>
                <StatProjects open={(cmp) => { }} />
                <p className='fm cw mb1 fs20'>Paramettre</p>
                <PaymentSettingsLink />
            </SideLeft>
        </MainLayout>

    );
};

export default MessageUser;